import { FormControl, Grid, MenuItem, Select, TextareaAutosize, TextField, Typography } from '@material-ui/core'
import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Select as AntDesignAutoComplete, Form } from 'antd';

import DatePicker from 'react-date-picker';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ValidateDateUTC } from '../../helpers/textValidation';
import moment from 'moment-timezone';
import { useState } from 'react';
import { Input, InputNumber, Switch } from 'antd';

const DynamicFormFields = ({ fields, onChange, grid, state, setState, page = "default" }) => {

    return (
        <>
            {
                fields.map((field) => (<DynamicFormField grid={grid} fields={field} onChange={onChange} state={state} setState={setState} page={page} />))
            }
        </>
    )
}

const DynamicFormField = ({ fields, onChange, type, grid, state, setState, page }) => {
    let Component = {
        1: <TextComponent grid={grid} onChange={onChange} data={fields} page={page} />,
        2: <DatePickerComponent grid={grid} onChange={onChange} data={fields} page={page} />,
        3: <DropDownComponent grid={grid} onChange={onChange} data={fields} page={page} />,
        4: <CheckRide grid={grid} state={state} setState={setState} data={fields} page={page} />,
        5: <TimeComponent grid={grid} onChange={onChange} data={fields} page={page} />,
        6: <TextAreaComponent grid={grid} onChange={onChange} data={fields} page={page} />,
        7: <Gap />,
        8: <RadioButton data={fields} onChange={onChange} page={page} />,
        9: <TextComponentByValue grid={grid} onChange={onChange} data={fields} page={page} />,
        10: <DropDownMUI grid={grid} onChange={onChange} data={fields} page={page} />,
        11: <DatePickerComponentUpdated grid={grid} onChange={onChange} data={fields} page={page} />,
        12: <TextRegexComponent state={state} grid={grid} onChange={onChange} data={fields} page={page} />,
    }
    return (
        Component[fields?.type]
    )
}

export default DynamicFormFields


const TextComponentByValue = ({ data, onChange, grid = false, page }) => {

    let { keyName, name, initial, isDisabled, message, isRequired, validation, type, fieldType, label, step, typography = false, value } = data;

    return (

        <Grid xs={12} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
            <div style={{ marginBottom: `${grid ? "0px" : "15px"}`, }}>

                <Grid xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px', fontWeight: '800' }}>{name}</Grid>
                <TextField
                    disabled={isDisabled}
                    defaultValue={initial}
                    label={label}
                    value={value}
                    type={fieldType}
                    style={{ background: 'white', borderRadius: '10px', marginBottom: `${grid ? "0px" : "20px"}` }}
                    id="outlined-basic"
                    errorMessages={['this field is required', 'email is not valid']}
                    onChange={(e) => onChange(e.target.value, keyName, type)}
                    required={isRequired}
                    placeholder={`${name} ${isRequired ? "*" : ""}`}
                    error={validation ? true : false}
                    helperText={validation != false ? validation : ""}
                    variant="outlined" className="w100p"
                    step={step}

                />
                {typography && <span style={{ fontSize: "10px", color: "lightgray" }} >
                    {typography}
                </span>}
            </div>

        </Grid>
    )
}

const Gap = () => {
    return <Grid xs={12}></Grid>
}


const DropDownMUI = ({ data, onChange, grid = false, page }) => {

    let { keyName, name, initial, options, key, isRequired, type, subKey, diffonChange = false, diffonChange2 = false, diffKey = false } = data;

    return (
        <Grid xs={12} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>

            <div style={{ marginBottom: `${grid ? "0px" : "20px"}` }}>
                <Grid xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px', fontWeight: '800' }}>{name}</Grid>
                <Select
                    labelId="demo-simple-select-label"
                    id="combo-box-demo"
                    value={""}
                    onChange={(e) => { }}
                >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                </Select>
            </div>
        </Grid>
    )
}

const TextAreaComponent = ({ data, onChange, grid = false, page }) => {

    let { name, initial, isRequired, placeHolder, minRows = 3, typography = false, keyName, type, maxLength } = data;

    return (

        <Grid xs={12} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
            <div style={{ marginBottom: `${grid ? "0px" : "15px"}` }}>

                <Grid xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px', fontWeight: '800' }}>{name}</Grid>
                <TextareaAutosize
                    required={isRequired}
                    id="comment1"
                    className="w100p dynamicTextarea"
                    rowsMin={minRows}
                    defaultValue={initial}
                    onChange={(e) => onChange(e.target.value, keyName, type)}
                    maxLength={maxLength}
                    // placeholder={name}
                    style={{ height: "150px" }}
                    minRows={minRows}
                />
                {typography && <span style={{ fontSize: "10px", color: "lightgray" }} >
                    {typography}
                </span>}
            </div>
        </Grid>
    )
}



const TextRegexComponent = ({ data, onChange, grid = false, page, state }) => {
    let { name, isRequired, keyName, type, fieldType, label, step, typography = false } = data;

    // Add your regex pattern here
    // const regexPattern = /^[a-zA-Z]+(\s\d*)?$/;
    // const regexPattern = /^[a-zA-Z].*$/;
    // const regexPattern = /^[a-zA-Z]+(\s\d*)?$/;
    const regexPattern = /^[a-zA-Z]+\s?\d*$/;


    state = state[type]

    const validateInput = ({ target: { value: inputValue } }) => {

        if ((inputValue != '') && (!regexPattern?.test(inputValue)))
            return onChange(state?.[keyName], keyName, type)
        onChange(inputValue, keyName, type);
    };




    return (
        <div>
            <div style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
                <div style={{ marginBottom: `${grid ? "0px" : "15px"}` }}>
                    <div xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px', fontWeight: '800' }}>{name}</div>
                    <TextField
                        label={label}
                        type={fieldType}
                        style={{ background: 'white', borderRadius: '10px', marginBottom: `${grid ? "0px" : "20px"}` }}
                        id="outlined-basic"
                        errorMessages={['this field is required', 'invalid format']}
                        onChange={validateInput}
                        required={isRequired}
                        placeholder={`${name} ${isRequired ? "*" : ""}`}
                        variant="outlined" className="w100p"
                        step={step}
                        value={state[keyName] || ''}
                    />
                    {typography && <span style={{ fontSize: "10px", color: "lightgray" }}>
                        {typography}
                    </span>}
                </div>
            </div>
        </div>
    );
};





const TextComponent = ({ data, onChange, grid = false, page }) => {

    let { keyName, name, initial, isDisabled, message, isRequired, validation, type, fieldType, label, step, typography = false, value, maxLength } = data;
    return (

        <Grid xs={12} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
            <div style={{ marginBottom: `${grid ? "0px" : "15px"}`, }}>

                <Grid xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px', fontWeight: '800' }}>{name}</Grid>
                <TextField
                    disabled={isDisabled}
                    defaultValue={initial}
                    label={label}
                    type={fieldType}
                    style={{ background: 'white', borderRadius: '10px', marginBottom: `${grid ? "0px" : "20px"}` }}
                    id="outlined-basic"
                    errorMessages={['this field is required', 'email is not valid']}
                    onChange={(e) => onChange(e.target.value, keyName, type)}
                    required={isRequired}
                    placeholder={`${name} ${isRequired ? "*" : ""}`}
                    error={validation ? true : false}
                    helperText={validation != false ? validation : ""}
                    variant="outlined" className="w100p"
                    step={step}
                    inputProps={{ maxLength: maxLength }}


                />
                {typography && <span style={{ fontSize: "10px", color: "lightgray" }} >
                    {typography}
                </span>}
            </div>

        </Grid>
    )
}

const DropDownComponent = ({ data, onChange, grid = false, page }) => {

    let { showForm = 'mui', keyName, name, initial, options, key, isRequired, type, subKey, diffonChange = false, diffonChange2 = false, diffKey = false } = data;

    return (
        <Grid xs={12} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>

            <div style={{ marginBottom: `${grid ? "0px" : "20px"}` }}>
                <Grid xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px', fontWeight: '800' }}>{name}</Grid>
                {
                    showForm == 'mui' ?
                        <Autocomplete
                            key={subKey ? subKey : ''}
                            className="w100p"
                            id="combo-box-demo"
                            options={options}
                            style={{ background: 'white', borderRadius: '10px' }}
                            getOptionLabel={(option) => diffKey === "supervisor" ? option?.firstName + " " + option?.lastName : option?.[key]}
                            defaultValue={initial}
                            onChange={(event, value) => diffonChange ? diffonChange(event, value) : diffonChange2 ? diffonChange2(value) : onChange(value, keyName, type)}
                            renderInput={(params) => <TextField {...params} variant="outlined" placeholder='Select'
                                required={isRequired}
                            />
                            }
                        />
                        :
                        <AntDesignAutoComplete
                            placeholder="Select"
                            options={options}
                            defaultValue={initial}
                            style={{ width: '100%', borderStyle: "none", borderRadius: "10px" }}
                            showSearch
                            filterOption={(input, option) =>
                                option?.label?.toLowerCase().includes(input.toLowerCase()) // Customize the search filter
                            }
                            onChange={(event, value) => diffonChange ? diffonChange(event, value) : diffonChange2 ? diffonChange2(value) : onChange(value, keyName, type)} />
                }
            </div>
        </Grid>
    )
}

const DatePickerComponent = ({ data, onChange, grid = false, page }) => {

    let { name, initial, keyName, type, datePickerType, isRequired, inputProps } = data;

    return (
        <Grid xs={12} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: "0px" }}>
            <div style={{ marginBottom: `${grid ? "0px" : "20px"}` }}>
                <Grid xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: "10px", marginTop: `${grid ? "20px" : "0px"}`, }}>{name}</Grid>
                {datePickerType === "mui" ?
                    <TextField
                        required={isRequired}
                        id="date1"
                        type="date"
                        className="DateTimePicker"
                        value={initial}
                        defaultValue="YY-MM-DD"
                        onChange={(event, value) => { onChange(event.target.value, keyName, type) }}
                        InputProps={
                            {
                                inputProps: {
                                    min: inputProps
                                }
                            }
                        }
                        formatDate={(date) =>
                            ValidateDateUTC(date)
                        }
                    /> : <DatePicker
                        value={initial}
                        required={true}
                        type="date"
                        onChange={(value) => onChange(value, keyName, type)}
                        id="date1"
                        style={{ background: 'white', borderRadius: '10px' }}
                        className="datePickerReact w100p bg-white react-date-picker"
                        message={'please fill this field'}

                        onCalendarClose={(e) => {
                        }}
                    />
                }

            </div>
        </Grid>
    )
}
const DatePickerComponentUpdated = ({ data, onChange, grid = false, page }) => {

    let { name, initial, keyName, type, datePickerType, isRequired, inputProps, disabledDate = null, maxDate = null, minDate = null } = data;

    return (
        <Grid xs={12} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: "0px" }}>
            <div style={{ marginBottom: `${grid ? "0px" : "20px"}` }}>
                <Grid xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: "10px", marginTop: `${grid ? "20px" : "0px"}`, }}>{name}</Grid>

                <DatePicker
                    value={initial}
                    required={true}
                    onChange={(value) => onChange(value, keyName, type)}
                    id="dob"
                    type='date1'
                    tileDisabledk={disabledDate}
                    style={{ background: 'white', borderRadius: '10px' }}
                    className="datePickerReact w100p bg-white react-date-picker"
                    message={'please fill this field'}
                    maxDate={maxDate}
                    minDate={minDate}
                />
            </div>
        </Grid>
    )
}


const TimeComponent = ({ data, onChange, grid = false, typography = false, page }) => {

    let { name, keyName, type, min = null, initial, isRequired = false } = data;

    return (
        <div style={{ marginBottom: `${page === 'incident' ? "0px" : "20px"}` }}>
            <Grid xs={6} style={{ marginBottom: '10px', marginTop: `${grid ? "20px" : "20px"}` }} className="mbold">{name}</Grid>
            <TextField
                required={isRequired}
                id="time"
                type="time"
                onChange={(e) => onChange(e.target.value, keyName, type)}
                className="DateTimePicker"
                defaultValue={initial}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            {typography && <Typography
                variant="h6"
                className="MuiTypography-subtitle2 MuiTypography-colorTextSecondary"
                component="h6"
            >
                {typography}
            </Typography>}
        </div>
    )
}


// const CondInput = (data) => {
//     let { value, onChange, cond } = data
//     return cond && <div style={{ marginBottom: "20px" }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//             <Input value={value} onChange={onChange} />
//         </div>
//     </div >
// }


const CheckRide = ({ data, state, setState, grid = false, page }) => {

    let { name, id, points, index } = data;

    return (
        <div style={{ marginBottom: "20px" }}>
            <Grid xs={12} style={{ marginBottom: '10px', fontWeight: '800', fontSize: "13px" }}>{name}</Grid>
            <FormControl
                required={true}>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    onChange={(e) => {
                        state[index] = { answer: e.target.value, CheckRideQuestionId: id, score: e.target.value === "N/A" ? 0 : points }
                        setState(prev => { return prev = [...state] })
                    }}
                >
                    <FormControlLabel control={<Radio required />} value="YES" label="Pass" />
                    <FormControlLabel control={<Radio required />} value="NO" label="Coach" />
                    <FormControlLabel control={<Radio required />} value="N/A" label="N/A" />
                </RadioGroup>
            </FormControl>
        </div >
    )
}




const RadioButton = ({ data, grid = false, page, onChange }) => {

    let { name, keyName, state } = data;

    return (
        <div style={{ marginBottom: "20px" }}>
            <Grid xs={12} style={{ marginTop: "20px", marginBottom: '10px', fontWeight: '800', fontSize: "13px" }}>{name}</Grid>
            <Switch checked={state[keyName]} onChange={(checked) => onChange(checked, keyName)} style={{ marginTop: "10px" }} />
        </div >
    )
}